/**
 * Analytics API client.
 * Provides aggregated performance data across channels and videos.
 */
import { apiGet } from "./client.ts";

export interface AnalyticsSummary {
  views: number[];
  watchHours: number[];
  subs: number[];
  revenue: number[];
  period: string;
  /** (tf3-34b) where view numbers are now: the old YouTube snapshot table is retired */
  note?: string;
}

export interface TopVideo {
  videoId: string;
  views: number;
  watchHours: number;
  ctr: number;
  avgView: string;
}

export interface ChannelBreakdown {
  id: string;
  views: number;
  watchHours: number;
  subs: number;
  revenue: number;
}

export interface HeatmapData {
  grid: number[][]; // 7 days x 8 hour blocks
}

export const analyticsApi = {
  summary: (params: { period?: string; channel?: string } = {}) => {
    const qs = new URLSearchParams();
    if (params.period) qs.set("period", params.period);
    if (params.channel && params.channel !== "all") qs.set("channel", params.channel);
    const q = qs.toString();
    return apiGet<AnalyticsSummary>(`/analytics/summary${q ? `?${q}` : ""}`);
  },

  topVideos: (params: { period?: string; channel?: string; limit?: number } = {}) => {
    const qs = new URLSearchParams();
    if (params.period) qs.set("period", params.period);
    if (params.channel && params.channel !== "all") qs.set("channel", params.channel);
    if (params.limit) qs.set("limit", String(params.limit));
    const q = qs.toString();
    return apiGet<{ videos: TopVideo[] }>(`/analytics/top-videos${q ? `?${q}` : ""}`);
  },

  byChannel: (params: { period?: string } = {}) => {
    const qs = params.period ? `?period=${params.period}` : "";
    return apiGet<{ channels: ChannelBreakdown[] }>(`/analytics/by-channel${qs}`);
  },

  heatmap: (params: { channel?: string } = {}) => {
    const qs = params.channel && params.channel !== "all" ? `?channel=${params.channel}` : "";
    return apiGet<HeatmapData>(`/analytics/heatmap${qs}`);
  },
};
